/// <reference types="sharepoint" />

import { InjectionToken } from '@angular/core';

export interface IMapper
{
    convertListItems(items:SP.ListItemCollection):Array<any>;
    convertItem(item:SP.ListItem):any;
}
export const MapperCONFIG = new InjectionToken<IMapper>('mapper');
